import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { flags } from './flags';

const LEFT = 'left';
const RIGHT = 'right';
const BOTH = 'both';

interface IContainerStylesProps {
  size: number;
  hasLeftMargin: boolean;
  hasRightMargin: boolean;
}

const useStyles = makeStyles({
  container: ({
    size,
    hasLeftMargin,
    hasRightMargin,
  }: IContainerStylesProps) => ({
    backgroundSize: 'contain',
    backgroundPosition: '50%',
    backgroundRepeat: 'no-repeat',
    position: 'relative' as 'relative',
    display: 'inline-block',
    width: '1.33333333em',
    lineHeight: '1em',
    fontSize: `${size}em`,
    marginLeft: hasLeftMargin ? '0.3em' : 0,
    marginRight: hasRightMargin ? '0.3em' : 0,
  }),
});

interface IProps {
  countryCode: string;
  size?: number;
  offset?: 'left' | 'right' | 'both';
}

export const CountryFlag: React.FunctionComponent<IProps> = ({
  countryCode,
  size = 1,
  offset,
}: IProps) => {
  const hasLeftMargin = offset === LEFT || offset === BOTH;
  const hasRightMargin = offset === RIGHT || offset === BOTH;

  const customClasses = useStyles({
    size,
    hasLeftMargin,
    hasRightMargin,
  });

  const countryFlag = flags[countryCode.toLowerCase()];

  if (!countryFlag) {
    return null;
  }

  return (
    <span
      className={customClasses.container}
      style={{ backgroundImage: `url(${countryFlag})` }}
    >
      &nbsp;
    </span>
  );
};
